import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { EmissionOverviewComponent } from './emission-overview.component';
import { EmissionOverviewRoutingModule } from './emission-overview-routing.module';



@NgModule({
  declarations: [EmissionOverviewComponent],
  imports: [
    CommonModule,
     MaterialModule,
                FormsModule,
                ReactiveFormsModule,
                CustomDropdownModule,
                CustomDatePickerModule,
                MaterialModule,
                CustomTimpickerModule,
                CustomInputModule,
                MatPaginatorModule,
                MatIconModule,
                MatTableModule,
                MatSortModule,
                ExpansionPanelModule,
                EmissionOverviewRoutingModule
  ]
})
export class EmissionOverviewModule { }
